// FinalServicesSection.js
import React from 'react';
import spinalCordCareImage from '../assets/spinal-cord-care-showcase.jpg';
import postOperativeCareImage from '../assets/post-operative-care-showcase.jpg';

const FinalServicesSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto space-y-16">
        
        {/* Spinal Cord Injury Care */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img 
              src={spinalCordCareImage} 
              alt="Caregiver with woman in wheelchair" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Spinal Cord Injury Care
            </h3>
            
            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Our spinal cord injury care is tailored to individuals living with partial or complete paralysis. The caregivers we match provide mobility assistance, daily living support, and safety monitoring to help clients maintain independence and quality of life at home. Each care plan is customised to meet the specific physical and emotional needs of the client.
              </p>
              
              <p>
                With experienced and compassionate caregivers, families can feel confident their loved ones are safe, supported, and empowered to live as fully as possible. From transfers and exercises to daily routines, our caregivers ensure that clients receive reliable care that promotes both safety and confidence.
              </p>
              
              <p className="font-normal">Our spinal cord injury care includes:</p>
            </div>
            
            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Mobility assistance</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Daily support</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Safety monitoring</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Post-Operative Care */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Post-Operative Care
            </h3>
            
            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Post-operative care helps seniors recover safely and comfortably after surgery or hospitalisation. The caregivers we refer assist with daily activities, medication reminders, wound care, and mobility, supporting a smooth and healthy recovery process.
              </p>
              
              <p>
                Families can trust that their loved ones are receiving professional, attentive care every step of the way. By providing personalised support and monitoring progress closely, our caregivers help clients regain strength, maintain independence, and return to their normal routines with confidence. We provide assistance with:
              </p>
            </div>
            
            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Wound care</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Medication reminders</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Mobility support</span>
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div>
            <img 
              src={postOperativeCareImage} 
              alt="Caregiver assisting elderly woman" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalServicesSection;
